// Package Imports
import { Injectable } from '@angular/core';
import { Observable, of, timer } from 'rxjs';

// Models
import { AuthUser, RegularExpressions, Result, UserSessionData } from '../../models';

// Services
import { AppConfigService } from '../app-config/app-config.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { OeHttpClientService } from '../oe-http-client/oe-http-client.service';
import { SessionService } from '../session/session.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly apiUrl: string;
  private readonly keepAliveUrl: string;
  private readonly parentLogoutUrl: string;

  constructor(private readonly appConfigService: AppConfigService,
              private readonly httpClient: OeHttpClientService,
              private readonly sessionService: SessionService,
              private readonly authService: AuthorizationService) {
    this.apiUrl = appConfigService.getData('apiEndpoint');
    this.keepAliveUrl = appConfigService.getData('keepAliveUrl');
    this.parentLogoutUrl = appConfigService.getData('logoutRedirect');
  }

  async getUserInfo(): Promise<Result<AuthUser>> {
    const requestUrl = `${this.apiUrl}/employer/userinfo`;
    return this.httpClient.get(requestUrl).toPromise();
  }

  getToday(): Promise<Date> {
    const requestUrl = `${this.apiUrl}/employer/today`;
    return this.httpClient.get(requestUrl).toPromise();
  }

  getPartnerImage(partner: string): Observable<any> {
    const responseUrl = `${this.apiUrl}/employer/partnerImage/${partner}`;
    return this.httpClient.get(responseUrl, { responseType: 'blob' });
  }

  public keepSessionAlive() {
    if (this.keepAliveUrl) {
      this.httpClient.get(this.keepAliveUrl).toPromise()
        .then(result => {
          if (result && result.DBChanged) {
            this.authService.logoutAndClose();
          }
        })
        .catch(() => {
          this.authService.logoutAndClose();
        });
    }
  }

  logoutParent(): Observable<any> {
    if (this.parentLogoutUrl) {
      return this.httpClient.get(this.parentLogoutUrl);
    }
    else {
      return of(true);
    }
  }

  getUserData(): UserSessionData {
    return this.sessionService.getSessionData(this.sessionService.sessionKey_UserSession);
  }

  public setupSessionAliveChecking() {
    const sessionAliveCheckIntervalInSeconds = this.appConfigService.getData('sessionAliveCheckIntervalInSeconds');

    if (sessionAliveCheckIntervalInSeconds) {
      timer(10000, sessionAliveCheckIntervalInSeconds * 1000).subscribe(() => this.keepSessionAlive());
    }
  }

  private retrieveRegularExpressions(): Observable<RegularExpressions> {
    return this.httpClient.get(`${this.apiUrl}/employers/regularexpressions`);
  }

  /* logUserLogin(portalType: string): Observable<Result<boolean>> {
      const deviceInfo = this.deviceService.getDeviceInfo();

      const data = {
          'PortalType': portalType,
          'BrowserName': deviceInfo.browser,
          'BrowserVersion': deviceInfo.browser_version,
          'UrlReferrer': window.location.href,
          'UserAgent': deviceInfo.userAgent
      };

      const requestUrl = `${this.apiUrl}/employer/logUserLogin`;
      return this.httpClient.post(requestUrl, JSON.stringify(data));
  }*/
}
